import React, { useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { IconButton, Collapse, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import BuildingAuthorityView from "Components/Common/FireSafetyBuildingViewDetailComponent/BuildingAuthorityView";
import GeneralInformationView from "Components/Common/FireSafetyBuildingViewDetailComponent/GeneralInformationView";
import ResponsiblePersonAuthorityView from "Components/Common/FireSafetyBuildingViewDetailComponent/ResponsiblePersonAuthorityView";
import FloorWiseTenantView from "Components/Common/FireSafetyBuildingViewDetailComponent/FloorWiseTenantView";
import UtilityMechanicalSystemView from "Components/Common/FireSafetyBuildingViewDetailComponent/UtilityMechanicalSystemView";
import ElectricalSystemView from "Components/Common/FireSafetyBuildingViewDetailComponent/ElectricalSystemView";
import FireProtectionView from "Components/Common/FireSafetyBuildingViewDetailComponent/FireProtectionView";
import AutomaticSprinklerSystemView from "Components/Common/FireSafetyBuildingViewDetailComponent/AutomaticSprinklerSystemView";
import FireDetectorSystemView from "Components/Common/FireSafetyBuildingViewDetailComponent/FireDetectorSystemView";
import FireDetectionTypeView from "Components/Common/FireSafetyBuildingViewDetailComponent/FireDetectionTypeView";
import FireFightingPumpDetailView from "Components/Common/FireSafetyBuildingViewDetailComponent/FireFightingPumpDetailView";
import FloorWiseFireExtinguisherView from "Components/Common/FireSafetyBuildingViewDetailComponent/FloorWiseFireExtinguisherView";
import FloorWiseFireProtectionEquipmentView from "Components/Common/FireSafetyBuildingViewDetailComponent/FloorWiseFireProtectionEquipmentView";
import FireLifeSafetyView from "Components/Common/FireSafetyBuildingViewDetailComponent/FireLifeSafetyView";
import RefugeAreaDetailView from "Components/Common/FireSafetyBuildingViewDetailComponent/RefugeAreaDetailView";
import FireSafetyDocumentView from "Components/Common/FireSafetyBuildingViewDetailComponent/FireSafetyDocumentView";

const FireSafetyViewBuildingInformationDetails = ({
  applicationData,
  title,
  floors,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggleCollapse = () => setIsExpanded((prev) => !prev);

  return (
    <>
      <div
        className="fs-4 fw-semibold mb-3 border-bottom cursor-pointer"
        onClick={handleToggleCollapse}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            sx={{ color: "#2e2e2e", fontSize: "21px", fontWeight: "bold" }}
          >
            {title}
          </Typography>
          <IconButton>
            {isExpanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Stack>
      </div>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        {!!applicationData && (
          <>
            {(!!applicationData?.buildingAuthority ||
              !!applicationData?.authority) && (
              <BuildingAuthorityView
                buildingAuthorities={[
                  applicationData?.authority,
                  applicationData?.buildingAuthority,
                ].filter((item) => item)}
              />
            )}
            {!!applicationData?.responsiblePersonAuthorities &&
              !!applicationData.responsiblePersonAuthorities.length && (
                <ResponsiblePersonAuthorityView
                  responsiblePersonAuthorities={
                    applicationData.responsiblePersonAuthorities
                  }
                />
              )}
            {!!applicationData && (
              <GeneralInformationView
                applicationData={applicationData}
                isTracking
              />
            )}
            {!!applicationData?.floorWiseTenants &&
              !!applicationData.floorWiseTenants.length && (
                <FloorWiseTenantView
                  floorWiseTenants={applicationData.floorWiseTenants}
                  floors={floors ?? []}
                />
              )}
            {applicationData?.utilityMechanicalSystem && (
              <UtilityMechanicalSystemView
                utilityMechanicalSystem={
                  applicationData.utilityMechanicalSystem
                }
                isTracking
              />
            )}
            {!!applicationData?.utilityMechanicalSystem?.electricalSystem && (
              <ElectricalSystemView
                electricalSystem={
                  applicationData.utilityMechanicalSystem.electricalSystem
                }
                isTracking
              />
            )}
            {!!applicationData?.fireProtection && (
              <>
                <FireProtectionView
                  fireProtection={applicationData.fireProtection}
                  isTracking
                />
                {!!applicationData.fireProtection.basementSprinklers
                  ?.length && (
                  <AutomaticSprinklerSystemView
                    sprinklers={
                      applicationData.fireProtection.basementSprinklers
                    }
                    floorOptions={floors}
                    isBasement
                  />
                )}
                {!!applicationData.fireProtection.floorSprinklers?.length && (
                  <AutomaticSprinklerSystemView
                    sprinklers={applicationData.fireProtection.floorSprinklers}
                    floorOptions={floors}
                  />
                )}

                <FireDetectorSystemView
                  fireProtection={applicationData.fireProtection}
                  isTracking
                />
                {!!applicationData.fireProtection.detectorSystems?.length && (
                  <FireDetectionTypeView
                    detectorSystems={
                      applicationData.fireProtection.detectorSystems
                    }
                    floorOptions={floors}
                  />
                )}
              </>
            )}
            {!!applicationData?.fireProtection?.fireFightingPumps &&
              !!applicationData.fireProtection.fireFightingPumps.length && (
                <FireFightingPumpDetailView
                  fireFightingPumps={
                    applicationData.fireProtection.fireFightingPumps
                  }
                />
              )}
            {!!applicationData?.fireProtection?.floorWiseFireExtinguishers &&
              !!applicationData.fireProtection.floorWiseFireExtinguishers
                .length && (
                <FloorWiseFireExtinguisherView
                  floorWiseFireExtinguishers={
                    applicationData.fireProtection.floorWiseFireExtinguishers
                  }
                />
              )}
            {!!applicationData?.floorWiseFireProtectionEquipments &&
              !!applicationData.floorWiseFireProtectionEquipments.length && (
                <FloorWiseFireProtectionEquipmentView
                  floorWiseFireProtectionEquipments={
                    applicationData.floorWiseFireProtectionEquipments
                  }
                />
              )}
            {!!applicationData?.lifeSafety && (
              <FireLifeSafetyView
                lifeSafety={applicationData.lifeSafety}
                isTracking
              />
            )}
            {!!applicationData?.lifeSafety?.refugeAreas &&
              !!applicationData.lifeSafety.refugeAreas.length && (
                <RefugeAreaDetailView
                  refugeAreas={applicationData.lifeSafety.refugeAreas}
                />
              )}
            {((!!applicationData?.lifeSafety?.dbrDocuments &&
              !!applicationData.lifeSafety.dbrDocuments.length) ||
              applicationData?.fireProtection
                ?.causeAndEffectMatrixDocumentUrl) && (
              <FireSafetyDocumentView
                causeAndEffectMatrixDocumentUrl={
                  applicationData?.fireProtection
                    ?.causeAndEffectMatrixDocumentUrl ?? ""
                }
                dbrDocuments={applicationData?.lifeSafety?.dbrDocuments}
              />
            )}
          </>
        )}
      </Collapse>
    </>
  );
};

FireSafetyViewBuildingInformationDetails.propTypes = {
  applicationData: PropTypes.object,
  title: PropTypes.string,
  floors: PropTypes.array,
};

export default FireSafetyViewBuildingInformationDetails;
